/* The custom builders' preview step, for the Custom CUBE and the Custom FRAME (one file since 2026-10-25; moved out of
   their sections 2026-10-24): the section says which builder it is in window.CF.BUILDER_KIND. */
(() => {
  const T = window.CF?.T?.preview || {};
  const API_URL = (window.CF?.CONSTANTS?.PREVIEW_API_URL || '').replace(/\/$/, '');
  /*
    One GET /preview/<id> at a time per design. Opening a design asked for its data credits and its combo pictures
    with two identical requests at the same moment (2026-10-26); callers now share the one in flight. Polls are not
    held back: each new call after the answer is a new request.
  */
  const previewInflight = {};
  function getPreviewData(designId) {
    if (!previewInflight[designId]) {
      previewInflight[designId] = fetch(`${API_URL}/preview/${encodeURIComponent(designId)}`)
        .then((res) => (res.ok ? res.json() : null))
        .finally(() => { delete previewInflight[designId]; });
    }
    return previewInflight[designId];
  }
  /*
    What differs between the two builders. A CUBE's model is 0.15 m of the scale on a side, a FRAME's 0.60 m. A
    FRAME is built as nine plates whose building count climbs as each lands, shown on one continuous bar; a CUBE is
    one mesh, its count shown once, on six step segments. A FRAME's renders take longer.
  */
  const IS_FRAME = window.CF.BUILDER_KIND === 'frame';
  const KIND = IS_FRAME ? 'frame' : 'cube';
  const PRODUCT = IS_FRAME ? 'FRAME' : 'CUBE';
  const SIDE_M = IS_FRAME ? 0.60 : 0.15;

  const btn         = document.getElementById('cube-custom-get-preview');
  const root        = document.getElementById('cube-custom-configurator');
  const changeBtn   = document.getElementById('cube-custom-change-location');
  const overlay     = document.getElementById('cube-custom-preview-overlay');
  const previewImg  = document.getElementById('cube-custom-preview-img');
  const errorEl     = document.getElementById('cube-custom-preview-error');
  const metaEl      = document.getElementById('cube-custom-preview-meta');
  const priceBlock  = document.getElementById('cube-custom-price-block');
  const genWrap     = document.getElementById('cube-custom-generating-content');
  const genIcons    = genWrap ? genWrap.querySelectorAll('.cf-gen-icon') : [];
  const genSteps    = genWrap ? genWrap.querySelectorAll('.cf-gen-step') : [];
  const genBarFill  = document.getElementById('cf-gen-fill'); /* the FRAME's one bar */
  const genLabel    = document.getElementById('cf-gen-stage-label');
  const genDetail   = document.getElementById('cf-gen-detail');

  if (!btn) return;

  function frameDims(scaleN) {
    return { width_m: SIDE_M * scaleN, height_m: SIDE_M * scaleN };
  }

  function setConfiguratorView(view) {
    if (!root) return;
    root.classList.toggle('cc-custom-view-location',  view === 'location');
    root.classList.toggle('cc-custom-view-preview',   view === 'preview');
    root.classList.toggle('cc-custom-view-customize', view === 'customize');
    if (view === 'location') window.CF_CUBE_CUSTOM_MAP?.refreshPreviousFrame?.();
    if (view === 'customize') {
      const did = currentDesignId || window.CF_CUBE_CUSTOM_PREVIEW?.design_id || null;
      loadAddonBase(did, addonComboFor(did));
      updateAddonOverlays();
    } else {
      stopAddonPoll();
    }
    requestAnimationFrame(() => {
      window.CF_CUBE_CUSTOM_MAP?.resize?.();
    });
  }

  const addonImg     = document.getElementById('cube-custom-addon-img');
  const addonCard    = document.querySelector('#cube-custom-preview-stage .cc-v3-image-area');
  const ADDON_PLACEHOLDER = addonImg ? (addonImg.dataset.placeholder || addonImg.src) : '';

  const addonBaseByDesign = {}; /* "designId|combo" -> step-3 composite URL (cache) */
  let addonPollTimer  = null;
  let addonPollKey    = null;
  let addonWantKey    = null; /* latest requested "designId|combo" — guards stale preloads */
  /*
    Show the step-3 composite only ONCE it has actually decoded — otherwise the
    loading pill/progress bar completes while the large 1500² JPEG is still
    downloading, leaving a 5-6s gap before the image appears. Preload, then swap
    + hide the loader together. Stale preloads (combo changed meanwhile) are dropped.
  */
  let addonWantUrl = null; /* the last picture asked for wins: a plain one still decoding never covers a marker's */
  function displayAddonImage(url, cacheKey) {
    if (!addonImg || !url) { showAddonLoading(false); return; }
    addonWantUrl = url;
    const pre = new Image();
    pre.decoding = 'async';
    const show = () => {
      if (addonWantKey !== cacheKey || addonWantUrl !== url) return;
      addonImg.src = url;
      showAddonLoading(false);
      updateAddonOverlays();
    };
    pre.onload = show;
    pre.onerror = show; /* even on error, stop the loader (fall back to whatever's shown) */
    pre.src = url;
    if (pre.complete) show();
  }

  function addonPlaqueEnabled() {
    return !!(window.CF?.STATE?.choices?.plaque);
  }
  function addonSelectedCover() {
    return (typeof getSelectedDisplayCover === 'function')
      ? getSelectedDisplayCover()
      : (window.CF?.STATE?.choices?.cover || 'none');
  }

  function refreshCoverOverlay(cover) {
    if (!addonCard) return;
    const existing = addonCard.querySelector('.cf-cover-overlay');
    if (cover === 'none' || !cover) { if (existing) existing.remove(); return; }
    const url = window.CF?.PRODUCT_DATA?.overlay?.[cover];
    if (!url) { if (existing) existing.remove(); return; }
    if (existing && existing.dataset.cover === cover) return;
    if (existing) existing.remove();
    const ov = document.createElement('img');
    ov.className = 'cf-cover-overlay';
    ov.dataset.cover = cover;
    ov.src = url;
    Object.assign(ov.style, {
      position: 'absolute', inset: '0', width: '100%', height: '100%',
      objectFit: 'cover', pointerEvents: 'none', zIndex: '10'
    });
    addonCard.appendChild(ov);
  }

  function refreshPlaqueOverlay(enabled) {
    if (!addonCard) return;
    let pl = addonCard.querySelector('.plaque-overlay');
    /*
      FRAME (2026-07-23): the plaque preview lives only in the plaque designer
      modal now — never render it on the gallery preview card. Strip any overlay.
    */
    if (!enabled || IS_FRAME) { if (pl) pl.remove(); return; }
    const isMobile = window.CF?.isMobile?.() ?? false;
    const cfg = (window.CF?.PLAQUE_GALLERY || {})[isMobile ? 'mobile' : 'desktop'] || {};
    if (!pl) {
      pl = document.createElement('div');
      pl.className = 'plaque-overlay';
      pl.innerHTML =
        '<span class="plaque-overlay-inner" data-city-index="1">' +
          '<span class="plaque-text-head"></span>' +
          '<span class="plaque-text-sub"></span>' +
        '</span>';
      addonCard.appendChild(pl);
    }
    Object.assign(pl.style, {
      position: 'absolute', zIndex: '11',
      top: cfg.top, left: '50%', transform: 'translateX(-50%)',
      width: cfg.width || 'auto', height: cfg.height || 'auto',
      pointerEvents: 'none'
    });
    const mat = window.CF?.STATE?.plaqueMaterial || 'steel';
    pl.classList.toggle('plaque-overlay--steel', mat === 'steel');
    pl.classList.toggle('plaque-overlay--brass', mat === 'brass');
    syncPlaqueText();
  }

  function syncPlaqueText() {
    if (!addonCard) return;
    const plaque = addonCard.querySelector('.plaque-overlay');
    if (!plaque) return;
    const inner = plaque.querySelector('.plaque-overlay-inner');
    if (!inner) return;

    const headlineInput = document.getElementById('plaque-note-1');
    const subInput      = document.getElementById('plaque-subnote-1');

    inner.innerHTML = '';

    const widthPx = plaque.clientWidth || 150;
    const headlineSize = widthPx * 0.06;
    const subSize      = widthPx * 0.03;

    const rawHeadline = headlineInput?.value.trim() || '';
    const previewHeadline = rawHeadline.toUpperCase().replace(/❤️|❤|♥/g, '♡');

    const h = document.createElement('span');
    h.className = 'plaque-text-head';
    h.textContent = previewHeadline;
    h.style.fontSize = headlineSize + 'px';
    h.style.fontWeight = 'bold';
    h.style.lineHeight = '1';
    h.style.textTransform = 'uppercase';
    h.style.color = '#3d3d3d';
    inner.appendChild(h);

    if (subInput && subInput.value.trim()) {
      const rawSub = subInput.value.trim();
      const previewSub = rawSub.toUpperCase().replace(/❤️|❤|♥/g, '♡');
      const s = document.createElement('span');
      s.className = 'plaque-text-sub';
      s.textContent = previewSub;
      s.style.fontSize = subSize + 'px';
      s.style.lineHeight = '1';
      s.style.textTransform = 'uppercase';
      s.style.color = '#3d3d3d';
      s.style.marginTop = '1px';
      inner.appendChild(s);
    }

    requestAnimationFrame(() => {
      const maxW = plaque.clientWidth;
      if (!maxW) return;
      const headEl = inner.querySelector('.plaque-text-head');
      const subEl  = inner.querySelector('.plaque-text-sub');
      if (!headEl) return;
      headEl.style.transform = '';
      if (subEl) subEl.style.transform = '';
      const wHead = headEl.offsetWidth;
      const wSub  = subEl ? subEl.offsetWidth : 0;
      const widest = Math.max(wHead, wSub);
      if (widest > maxW && widest > 0) {
        const scale = (maxW / widest) * 0.95;
        inner.style.transform = 'scale(' + scale + ')';
        inner.style.transformOrigin = 'center';
      } else {
        inner.style.transform = '';
      }
    });
  }

  function updateAddonOverlays() {
    refreshCoverOverlay(addonSelectedCover());
    refreshPlaqueOverlay(addonPlaqueEnabled());
  }
  window.CF_CUBE_CUSTOM_updateAddonOverlays = updateAddonOverlays;
  window.CF_CUBE_CUSTOM_syncPlaqueText = syncPlaqueText;
  /*
    While `on`, the placeholder (the empty CUBE or FRAME) is shown and the plaque/cover
    overlays are held back (is-addon-loading). Also drives the SAME
    "Preview is updating…" pill + ETA bar used by the gallery, so step 3 shows
    the identical loading animation while the server-side composite renders.
  */
  let addonRenderStartAt = 0;
  function showAddonLoading(on) {
    if (addonCard) addonCard.classList.toggle('is-addon-loading', on);
    if (root) root.classList.toggle('cc-addon-rendering', on);
    if (processing) {
      if (on) {
        if (!addonRenderStartAt) addonRenderStartAt = Date.now();
        processing.classList.add('is-visible');
        setProgressBar(true, addonRenderStartAt, addonRenderStartAt + ADDON_RENDER_MS);
      } else {
        addonRenderStartAt = 0;
        processing.classList.remove('is-visible');
        setProgressBar(false);
        setProcessingSub('');
      }
    }
  }

  function stopAddonPoll() {
    if (addonPollTimer) { clearTimeout(addonPollTimer); addonPollTimer = null; }
    addonPollKey = null;
  }
  /*
    Which combo the shopper selected in step 2, read from the persisted preview
    object (persistComboOnPreview keeps p.trees/p.streets in sync with the toggles,
    and the ATC props read the same fields — single source of truth).
  */
  function addonComboFor(designId) {
    const p = window.CF_CUBE_CUSTOM_PREVIEW;
    if (!p || p.design_id !== designId) return 'model';
    if (p.trees && p.streets) return 'both';
    if (p.trees)   return 'trees';
    if (p.streets) return 'streets';
    return 'model';
  }
  /*
    Step 3: show the server-side composite for the selected combo (model / trees /
    streets / both — eye-level over top-down). The GET /preview/{id}/addon?combo=
    call expedites the render (priority) if it isn't ready yet; until then the CDN
    placeholder stays up. Cached + polled per (designId, combo).
  */
  function loadAddonBase(designId, combo) {
    combo = combo || 'model';
    if (!designId || !API_URL || !addonImg) { showAddonLoading(false); return; }
    const cacheKey = designId + '|' + combo;
    addonWantKey = cacheKey;
    /*
      A location marker stands on it: its picture, and no plain one after it (the plain poll stops — it used to land
      a few seconds later and take the marker away again). While the marker's picture is still rendering the loader
      stays up; the marker script calls refreshAddon when it is there, or when it failed (then the plain one shows).
    */
    window.CF.MARKER?.onStep3?.(designId, combo);   /* the marker's top view of this combo, for its window */
    const marked = window.CF.MARKER?.addonFor?.(designId, combo);
    if (marked) { stopAddonPoll(); displayAddonImage(marked, cacheKey); return; }
    const markerComing = !!window.CF.MARKER?.pendingFor?.(designId, combo);
    if (addonBaseByDesign[cacheKey] && !markerComing) { /* cached → decode (usually instant) then show */
      displayAddonImage(addonBaseByDesign[cacheKey], cacheKey);
      return;
    }
    if (addonPollKey === cacheKey && addonPollTimer) return;
    /*
      Switched combo before the previously-requested one started rendering: pull it
      off the addon queue so abandoned selections don't pile up behind this one
      (no-op server-side if it already started/finished). Only for a still-unresolved
      other combo of the SAME design.
    */
    if (addonPollKey && addonPollKey !== cacheKey && !addonBaseByDesign[addonPollKey] && API_URL) {
      const prev = addonPollKey.split('|');
      if (prev.length === 2) {
        fetch(API_URL + '/preview/' + encodeURIComponent(prev[0]) + '/addon/cancel?combo=' + encodeURIComponent(prev[1]),
              { method: 'POST', keepalive: true }).catch(() => {});
      }
    }
    stopAddonPoll();
    addonPollKey = cacheKey;
    /*
      Stop polling after ~4 min: the add-on queue shares workers with the
      preview/frame renders, so an on-demand combo add-on can wait behind a big
      generation — 2 min was too short and gave up before its turn came (bar
      vanished, no image). Still bounded so a truly stuck design (e.g. its
      background render was cancelled) doesn't load forever.
    */
    const addonPollDeadline = Date.now() + 240000;
    if (ADDON_PLACEHOLDER) addonImg.src = ADDON_PLACEHOLDER;
    setProcessingSub(combo);
    showAddonLoading(true);

    const poll = async () => {
      if (addonPollKey !== cacheKey) return;
      if (Date.now() > addonPollDeadline) { showAddonLoading(false); stopAddonPoll(); return; }
      try {
        const res = await fetch(API_URL + '/preview/' + encodeURIComponent(designId) + '/addon?combo=' + encodeURIComponent(combo));
        const data = await res.json().catch(() => ({}));
        if (addonPollKey !== cacheKey) return;
        if (data.addon_status === 'ready' && data.addon_base_url) {
          addonBaseByDesign[cacheKey] = data.addon_base_url;
          stopAddonPoll();
          if (window.CF.MARKER?.pendingFor?.(designId, combo)) return; /* the marker's picture follows (above) */
          displayAddonImage(data.addon_base_url, cacheKey); /* keep the loader up until it decodes */
          return;
        }
      } catch (e) { }
      if (addonPollKey === cacheKey) addonPollTimer = setTimeout(poll, 2500);
    };
    poll();
  }

  ['plaque-note-1', 'plaque-subnote-1'].forEach(function (id) {
    const el = document.getElementById(id);
    if (el) el.addEventListener('input', function () {
      if (root?.classList.contains('cc-custom-view-customize')) syncPlaqueText();
    });
  });
  /*
    Funnel telemetry, step 1: this shopper opened the configurator. Fired once
    per page load, fire-and-forget. Nothing is stored on the device and no id is
    sent — the API derives a session key from the request itself, so it dedupes
    per person per day on its own. That's also why this needs no consent gate:
    the banner governs storing/reading data on the device, and this stores none.
  */
  if (API_URL) {
    fetch(API_URL + '/configurator/visit', { method: 'POST', keepalive: true }).catch(() => {});
  }
  /*
    Funnel telemetry: design_ids whose step-3 marker we've already POSTed this
    page load, so re-entering Customize doesn't re-hit the endpoint.
  */
  const _step3Marked = new Set();
  window.CF_CUBE_CUSTOM_onEnterCustomize = function () {
    const did = currentDesignId || window.CF_CUBE_CUSTOM_PREVIEW?.design_id || null;
    loadAddonBase(did, addonComboFor(did));
    updateAddonOverlays();
    /*
      Record (once per design, best-effort) that this design reached the
      "Customize & order" step. Powers the owner funnel's step-3 count. Fire the
      public API directly (not the save proxy) — no auth needed, keyed to the id.
    */
    if (did && API_URL && !_step3Marked.has(did)) {
      _step3Marked.add(did);
      fetch(API_URL + '/design/' + encodeURIComponent(did) + '/step3',
        { method: 'POST', keepalive: true }).catch(() => {});
    }
  };
  window.CF_CUBE_CUSTOM_onLeaveCustomize = function () { stopAddonPoll(); showAddonLoading(false); };

  const STEP_KEYS = ['area', 'map', 'terrain', 'buildings', 'model', 'render'];
  const STAGE_DEFAULTS = {
    area:      { label: 'Preparing your area',     detail: 'Locating your selection on the map' },
    map:       { label: 'Loading map data',        detail: 'Streets, parks, and landmarks' },
    terrain:   { label: 'Shaping the terrain',     detail: 'Elevation, hills, and water' },
    buildings: { label: 'Placing buildings',       detail: '' },
    model:     { label: 'Assembling the 3D model', detail: 'Stacking layers' },
    render:    { label: `Rendering your ${PRODUCT}`, detail: 'Almost there…' },
  };
  const STAGE_TEXT = STEP_KEYS.reduce((acc, k) => {
    const fromCF = T.stages?.[k];
    acc[k] = {
      label:  fromCF?.label  || STAGE_DEFAULTS[k].label,
      detail: fromCF?.detail || STAGE_DEFAULTS[k].detail,
    };
    return acc;
  }, {});

  const STAGE_TIDBITS = {
    area: [
      window.CF.BUILDER_T["gen_step_area_detail"],
      window.CF.BUILDER_T["tidbit_area_2"],
      window.CF.BUILDER_T["tidbit_area_3"],
    ],
    map: [
      window.CF.BUILDER_T["gen_step_map_detail"],
      window.CF.BUILDER_T["tidbit_map_2"],
      window.CF.BUILDER_T["tidbit_map_3"],
      window.CF.BUILDER_T["tidbit_map_4"],
    ],
    terrain: [
      window.CF.BUILDER_T["gen_step_terrain_detail"],
      window.CF.BUILDER_T["tidbit_terrain_2"],
      window.CF.BUILDER_T["tidbit_terrain_3"],
      window.CF.BUILDER_T["tidbit_terrain_4"],
    ],
    buildings: [
      window.CF.BUILDER_T["tidbit_buildings_1"],
      window.CF.BUILDER_T["tidbit_buildings_2"],
      window.CF.BUILDER_T["tidbit_buildings_3"],
      window.CF.BUILDER_T["tidbit_buildings_4"],
    ],
    model: [
      window.CF.BUILDER_T["gen_step_model_detail"],
      window.CF.BUILDER_T["tidbit_model_2"],
      window.CF.BUILDER_T["tidbit_model_3"],
      window.CF.BUILDER_T["tidbit_model_4"],
    ],
    render: [
      window.CF.BUILDER_T["gen_step_render_detail"],
      window.CF.BUILDER_T["tidbit_render_2"],
      window.CF.BUILDER_T["tidbit_render_3"],
      window.CF.BUILDER_T["tidbit_render_4"],
    ],
  };
  const TIDBIT_INTERVAL_MS = 3000;
  let tidbitTimer = null;
  let tidbitIndex = 0;
  /*
    Steps advance from real backend progress via the paced display loop
    (renderProgress → setStep), so there is no timer-driven pacing here.
  */
  let currentStep = -1;
  let counterRAF  = null;
  let genDeferTimer = null;
  let persistedBuildingCount = null;
  let persistedParksCount    = null;
  let persistedWaterCount    = null;
  /*
    CUBE: "Generating buildings" (step 3) count-up gate: the count-up lives only in
    showBuildingsGenerating, so if buildings_count lands after the display has
    already raced past step 3 (fast build), it's silently skipped. These hold the
    display at step 3 until the count lands and its count-up plays out.
  */
  let step3EnteredAt   = 0; /* when the display first wanted to leave step 3 without a count */
  let countUpStartedAt = 0; /* when the count-up animation actually began */
  const BUILDINGS_GATE_MS = 30000; /* hard cap holding "Generating" while waiting for buildings_count */
  const COUNTUP_HOLD_MS   = 2700; /* hold after the count-up starts so it finishes under "Generating" */


  function extractBuildingCount(stage) {
    if (!stage) return null;
    const m = String(stage).match(/([\d.,]+)\s+buildings?/i);
    if (!m) return null;
    const n = parseInt(m[1].replace(/[,.\s]/g, ''), 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function setStep(step) {
    if (step === currentStep) return;
    currentStep = step;
    genIcons.forEach(el => el.classList.toggle('is-active', Number(el.dataset.step) === step));
    genSteps.forEach(el => {
      const i = Number(el.dataset.step);
      el.classList.toggle('is-done',   i <  step);
      el.classList.toggle('is-active', i === step);
    });
  }

  function swapText(el, newText) {
    if (!el) return;
    el.classList.add('is-swapping');
    setTimeout(() => {
      el.textContent = newText;
      el.classList.remove('is-swapping');
    }, 180);
  }

  function animateCounter(el, to, dur = 2500) {
    if (!el) return;
    if (counterRAF) cancelAnimationFrame(counterRAF);
    /*
      Climb from whatever is currently shown (not always 0), so a FRAME's
      aggregated count can tick UP smoothly as each plate's buildings land.
      (A CUBE's counter is always new, at 0.)
    */
    const from = parseInt((el.textContent || '0').replace(/[^\d]/g, ''), 10) || 0;
    if (to <= from) { el.textContent = to.toLocaleString(); return; }
    const t0 = performance.now();
    function tick(t) {
      const k = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(from + (to - from) * eased).toLocaleString();
      if (k < 1) counterRAF = requestAnimationFrame(tick);
    }
    counterRAF = requestAnimationFrame(tick);
  }

  function showBuildingsGenerating(n) {
    countUpStartedAt = performance.now(); /* gate: keep step 3 up until this count-up finishes */
    if (genLabel) {
      genLabel.classList.add('is-swapping');
      setTimeout(() => {
        genLabel.innerHTML = (window.CF?.T?.cube_custom?.generating_buildings || 'Generating __N__ buildings').replace('__N__', '<strong id="cf-gen-counter">0</strong>');
        genLabel.classList.remove('is-swapping');
        animateCounter(document.getElementById('cf-gen-counter'), n);
      }, 180);
    }
    swapText(genDetail, '');
  }

  function showBuildingsPlacing(n) {
    swapText(genLabel, (window.CF?.T?.cube_custom?.placing_buildings || 'Placing %n% buildings').replace('%n%', n.toLocaleString()));
    swapText(genDetail, buildFeatureDetail());
  }
  /*
    FRAME: building count for step 3 ("Generating N buildings") and step 4 ("Placing N
    buildings") — both render an animated #cf-gen-counter so the FRAME's climbing
    aggregate ticks up. relabel=true re-renders the label (on a step change);
    relabel=false just animates the existing counter (on a count update).
  */
  function showBuildingsCount(step, n, relabel) {
    const CT = window.CF?.T?.cube_custom || {};
    const existing = document.getElementById('cf-gen-counter');
    /*
      The count-up belongs to "Generating buildings" (step 3): it animates as each
      plate's buildings land. By "Placing buildings" (step 4) the plate total is
      final, so the number shows SETTLED (no count-up) — the climb finished with
      the Generating step, which is what the shopper expects.
    */
    const settle = step === 4;
    if (existing && !relabel) {
      if (settle) existing.textContent = n.toLocaleString();
      else        animateCounter(existing, n);
      if (step === 4) swapText(genDetail, buildFeatureDetail());
      return;
    }
    /*
      Seed the new counter with whatever is already shown (0 on first display,
      the current count on a step 3→4 relabel) so it never flashes back to 0.
    */
    const startVal = existing
      ? (parseInt((existing.textContent || '0').replace(/[^\d]/g, ''), 10) || 0) : 0;
    const span = `<strong id="cf-gen-counter">${(settle ? n : startVal).toLocaleString()}</strong>`;
    const raw = step === 4
      ? (CT.placing_buildings   || 'Placing %n% buildings')
      : (CT.generating_buildings || 'Generating __N__ buildings');
    const html = raw.replace('%n%', span).replace('__N__', span);
    if (genLabel) {
      genLabel.classList.add('is-swapping');
      setTimeout(() => {
        genLabel.innerHTML = html;
        genLabel.classList.remove('is-swapping');
        const cEl = document.getElementById('cf-gen-counter');
        /*  Step 4 renders the final total directly (settled); step 3 counts up. */
        if (settle) { if (cEl) cEl.textContent = n.toLocaleString(); }
        else animateCounter(cEl, n);
      }, 180);
    }
    swapText(genDetail, step === 4 ? buildFeatureDetail() : '');
  }

  function buildFeatureDetail() {
    const CT = window.CF?.T?.cube_custom || {};
    const parts = [];
    if (currentStep === 5 && persistedBuildingCount != null) {
      parts.push((CT.count_buildings || '%n% buildings').replace('%n%', persistedBuildingCount.toLocaleString()));
    }
    if (persistedParksCount != null && persistedParksCount >= 0) {
      parts.push((CT.count_parks || '%n% parks').replace('%n%', persistedParksCount.toLocaleString()));
    }
    if (persistedWaterCount != null && persistedWaterCount >= 0) {
      parts.push((CT.count_water || '%n% water features').replace('%n%', persistedWaterCount.toLocaleString()));
    }
    return parts.length ? parts.join(' • ') : '';
  }

  function stopTidbitRotation() {
    if (tidbitTimer) { clearInterval(tidbitTimer); tidbitTimer = null; }
    tidbitIndex = 0;
  }

  function startTidbitRotation() {
    stopTidbitRotation();
    if (currentStep < 0) return;
    if ((currentStep === 3 || currentStep === 4) && persistedBuildingCount != null) return;
    const list = STAGE_TIDBITS[STEP_KEYS[currentStep]];
    if (!list || list.length <= 1) return;
    tidbitIndex = 0;
    tidbitTimer = setInterval(() => {
      const stillActive = currentStep >= 0
        && !((currentStep === 3 || currentStep === 4) && persistedBuildingCount != null);
      if (!stillActive) { stopTidbitRotation(); return; }
      const stepList = STAGE_TIDBITS[STEP_KEYS[currentStep]];
      if (!stepList) return;
      tidbitIndex = (tidbitIndex + 1) % stepList.length;
      if (genDetail) swapText(genDetail, stepList[tidbitIndex]);
    }, TIDBIT_INTERVAL_MS);
  }

  function syncStageText(step) {
    if (step === 3 && persistedBuildingCount != null) {
      if (IS_FRAME) showBuildingsCount(3, persistedBuildingCount, true);
      else showBuildingsGenerating(persistedBuildingCount);
      stopTidbitRotation();
      return;
    }
    if (step === 4 && persistedBuildingCount != null) {
      if (IS_FRAME) showBuildingsCount(4, persistedBuildingCount, true);
      else showBuildingsPlacing(persistedBuildingCount);
      stopTidbitRotation();
      return;
    }
    if (step === 5 && persistedBuildingCount != null) {
      const def = STAGE_TEXT[STEP_KEYS[5]];
      swapText(genLabel, def.label);
      swapText(genDetail, buildFeatureDetail() || def.detail);
      stopTidbitRotation();
      return;
    }
    const def = STAGE_TEXT[STEP_KEYS[step]];
    swapText(genLabel,  def.label);
    swapText(genDetail, def.detail);
    startTidbitRotation();
  }

  function applyStage(data) {
    const obj = (data && typeof data === 'object') ? data : null;
    const stage = obj ? obj.stage : data;

    const apiBuildings = obj ? obj.buildings_count : null;
    if (IS_FRAME) {
      /*
        FRAME counts are AGGREGATED across the 9 plates and CLIMB as each completes,
        so track the LATEST (largest) value and re-animate — instead of freezing the
        first partial (which showed e.g. "Placing 373 buildings • 1 water feature").
      */
      const nB = (apiBuildings != null && Number.isFinite(apiBuildings) && apiBuildings > 0)
        ? apiBuildings
        : extractBuildingCount(stage);
      if (nB != null && (persistedBuildingCount == null || nB > persistedBuildingCount)) {
        persistedBuildingCount = nB;
        if (currentStep === 3 || currentStep === 4) {
          stopTidbitRotation();
          showBuildingsCount(currentStep, nB, false);
        }
      }
    } else if (persistedBuildingCount == null) {
      const n = (apiBuildings != null && Number.isFinite(apiBuildings) && apiBuildings > 0)
        ? apiBuildings
        : extractBuildingCount(stage);
      if (n != null) {
        persistedBuildingCount = n;
        if (currentStep === 3 || currentStep === 4) {
          stopTidbitRotation();
        }
        /*
          The count-up MUST play before "Placing": if the count lands late (already
          at step 4) and the count-up never ran, still show "Generating" first.
        */
        if (currentStep === 3 || (currentStep === 4 && !countUpStartedAt)) {
          showBuildingsGenerating(n);
        } else if (currentStep === 4) {
          showBuildingsPlacing(n);
        }
      }
    }

    const apiParks = obj ? obj.parks_count : null;
    const apiWater = obj ? obj.water_count : null;
    let countsChanged = false;
    /*  The CUBE keeps its first count; a FRAME's climbs with its plates, so it keeps the largest. */
    if (Number.isFinite(apiParks) && apiParks >= 0
        && (persistedParksCount == null || (IS_FRAME && apiParks > persistedParksCount))) {
      persistedParksCount = apiParks; countsChanged = true;
    }
    if (Number.isFinite(apiWater) && apiWater >= 0
        && (persistedWaterCount == null || (IS_FRAME && apiWater > persistedWaterCount))) {
      persistedWaterCount = apiWater; countsChanged = true;
    }
    if (countsChanged && currentStep >= 4 && persistedBuildingCount != null) {
      stopTidbitRotation();
      swapText(genDetail, buildFeatureDetail());
    }
    /*
      Feed the REAL backend progress (0-100 from the API - CUBE: mesh build 5-60%, then
      render 65-96% for model + Trees; FRAME: plate build 5-50%, render 50-96%) to the
      paced display loop below.
    */
    if (obj && Number.isFinite(obj.progress)) {
      setTargetProgress(Math.max(0, Math.min(100, obj.progress)));
    }
  }
  /*
    Real-progress → step + each step's progress range. Mirrors api._compute_progress's milestones.
    CUBE: mesh build (5-60%) spans steps 0-4 (area…model); the render half (65%+, model + Trees) is step 5.
    FRAME: plate build (backend 5-50%) spans steps 0-3, so step 3 ("Generating N buildings") ENDS at 52 — a hair
    past the 50% "plates done" milestone — which lets the aggregated building count-up finish under the
    "Generating" label. Step 4 ("Placing N buildings", 52-60) is the model-build plateau (backend flat 50%,
    bridged by the trickle) where the total shows settled. Step 5 (60-100) is the render half.
  */
  const STEP_PROGRESS = IS_FRAME
    ? [[0,10],[10,22],[22,36],[36,52],[52,60],[60,100]]
    : [[0,12],[12,22],[22,33],[33,48],[48,65],[65,100]];
  function progressToStep(p) {
    for (let i = STEP_PROGRESS.length - 1; i >= 0; i--) { if (p >= STEP_PROGRESS[i][0]) return i; }
    return 0;
  }
  /*
    Paced progress: the DISPLAY eases toward the real API target at a capped rate,
    so a warm/instant build still reveals steps 1-3 (min ~1.4s each) instead of
    snapping to ~75%. The cap only bites when the real value jumps ahead of the
    display; a slow later step lets the display catch up. It never exceeds reality.
  */
  let targetProgress = 0, displayProgress = 0, progressRAF = null, lastFrameT = 0, genStartT = 0;
  let lastFillQ = -1, lastFillStep = -1; /* dedup the per-frame fill writes (see renderProgress) */
  const PROGRESS_MIN_FULL_MS = 8500; /* ease cap: display can't jump faster than 0→100 in ~8.5s */
  /*  The front-phase time curve stops just below the CUBE's ~60% "mesh built" / the FRAME's 50% "plates done". */
  const FRONT_CAP = IS_FRAME ? 49 : 59;
  const FRONT_TAU_MS = IS_FRAME ? 38000 : 30000; /* front ease-out time constant (bigger = climbs more gradually) */
  const PROGRESS_LEAD        = 7; /* display may lead a FLAT backend signal by this much */
  const PROGRESS_TRICKLE_MS  = 300000; /* trickle rate while leading (~0.33%/s — slow, alive) */
  /*
    ATTACHING to a render that is already under way (the shopper left during a
    generation and came back to it). The paced ramp and the front curve exist to
    make a NEW build feel alive — a warm build deliberately still walks steps 1-3
    rather than snapping to ~75%. Replaying that for a job already at, say, 70%
    just makes the shopper watch ~7 s of theatre narrating work that finished
    minutes ago, so the first real reading is ADOPTED outright instead.
    Set only by watchPending; a fresh generation is unaffected.
  */
  let resumeAdopt = false, skipBuildingsGate = false;
  function setTargetProgress(p) {
    targetProgress = Math.max(targetProgress, p);
    if (!resumeAdopt || targetProgress <= displayProgress) return;
    resumeAdopt = false;
    displayProgress = targetProgress;
    /*
      Rebase the time-paced front curve so it CONTINUES from the adopted value
      instead of climbing from zero again (it's a floor via Math.max, so a stale
      genStartT would leave the bar frozen until the next backend update).
    */
    if (genStartT) {
      const el = displayProgress >= FRONT_CAP
        ? FRONT_TAU_MS * 12
        : -FRONT_TAU_MS * Math.log(1 - displayProgress / FRONT_CAP);
      genStartT = performance.now() - el;
    }
    /*  A FRAME's step follows on the next frame (renderProgress). */
    if (IS_FRAME) return;
    /*
      Jumping past the buildings count-up: it introduces a NEW build's building
      count, so holding step 3 for it here would re-narrate a stage long done.
    */
    if (progressToStep(displayProgress) > 3) skipBuildingsGate = true;
    setStep(progressToStep(displayProgress));
    syncStageText(progressToStep(displayProgress));
  }
  function renderProgress(p) {
    let st = progressToStep(p);
    /*
      Hold at "Generating buildings" (step 3) until its count-up has actually PLAYED,
      so "Placing buildings" (step 4) can never appear first. Two failure modes this
      guards: (a) buildings_count lands late (slow build) — hold through the build
      until it arrives; (b) the display jumps past step 3 before the count-up starts.
      Released the instant the count-up has run (COUNTUP_HOLD_MS after it starts), or
      if the backend clearly reached the render phase (count isn't coming), or after
      a hard cap so it can never truly stall.
    */
    if (!IS_FRAME && st > 3 && currentStep <= 3 && !skipBuildingsGate) {
      const now = performance.now();
      if (!countUpStartedAt) {
        if (!step3EnteredAt) step3EnteredAt = now;
        const buildDone = targetProgress >= 64;
        if (!buildDone && (now - step3EnteredAt) < BUILDINGS_GATE_MS) st = 3;
      } else if ((now - countUpStartedAt) < COUNTUP_HOLD_MS) {
        st = 3; /* count-up is playing — let it finish under "Generating" */
      }
    }
    if (st > currentStep) { setStep(st); syncStageText(st); }
    /*
      (Gate + step transition above run every frame — time-based.) The rAF loop runs
      for the whole (minutes-long) generation; during frozen and slow-trickle
      stretches p barely moves. Skip the per-frame DOM writes unless the visible fill
      actually changed (0.1% resolution — finer than the eye).
    */
    const q = Math.round(p * 10);
    if (IS_FRAME) {
      /*  The FRAME's single continuous bar: fill = the overall paced progress. */
      if (q === lastFillQ) return;
      lastFillQ = q;
      if (genBarFill) genBarFill.style.width = Math.max(0, Math.min(100, p)) + '%';
      return;
    }
    if (q === lastFillQ && currentStep === lastFillStep) return;
    lastFillQ = q; lastFillStep = currentStep;
    genSteps.forEach((el) => {
      const i = Number(el.dataset.step);
      const r = STEP_PROGRESS[i];
      const frac = i < currentStep ? 1 : i > currentStep ? 0
        : Math.max(0, Math.min(1, (p - r[0]) / Math.max(1, r[1] - r[0])));
      el.style.setProperty('--cf-fill', String(frac));
    });
  }
  function tickProgress(t) {
    if (!genStartT) genStartT = t;
    const dt = lastFrameT ? Math.min(100, t - lastFrameT) : 16; lastFrameT = t;
    const el = t - genStartT;
    /*
      The FRONT phase (CUBE: mesh build, incl. the slow terrain fetch; FRAME: plan +
      9-plate build, ~120s with terrain, ~15s flat) is TIME-paced on an ease-out
      curve so it glides smoothly and consistently instead of sitting at the
      backend's flat signal mid-step. Real backend progress is only a FLOOR (a warm
      build pulls the bar forward); the curve caps just below the "mesh built" /
      "plates done" milestone so it never claims it before the backend is there.
    */
    const front = Math.min(FRONT_CAP, FRONT_CAP * (1 - Math.exp(-el / FRONT_TAU_MS)));
    const target = Math.max(targetProgress, front);
    if (displayProgress < target) {
      /*  Ease toward the (real or front-curve) target at the capped rate. */
      displayProgress = Math.min(target, displayProgress + (100 / PROGRESS_MIN_FULL_MS) * dt);
    } else if (displayProgress >= FRONT_CAP && displayProgress < 96) {
      /*
        Back half (render) only: caught up to a FLAT backend signal → trickle so
        the bar is never frozen, but never lead the real target by more than
        PROGRESS_LEAD — the honest render milestones drive the big moves.
      */
      const ceil = Math.min(96, target + PROGRESS_LEAD);
      if (displayProgress < ceil)
        displayProgress = Math.min(ceil, displayProgress + (100 / PROGRESS_TRICKLE_MS) * dt);
    }
    renderProgress(displayProgress);
    progressRAF = requestAnimationFrame(tickProgress);
  }
  function startProgressLoop() {
    displayProgress = 0; targetProgress = 0; lastFrameT = 0; genStartT = 0;
    lastFillQ = -1; lastFillStep = -1;
    if (!progressRAF) progressRAF = requestAnimationFrame(tickProgress);
  }
  function stopProgressLoop() {
    if (progressRAF) { cancelAnimationFrame(progressRAF); progressRAF = null; }
  }

  function resetGenerating() {
    if (counterRAF) { cancelAnimationFrame(counterRAF); counterRAF = null; }
    stopTidbitRotation();
    currentStep = -1;
    persistedBuildingCount = null;
    persistedParksCount    = null;
    persistedWaterCount    = null;
    step3EnteredAt         = 0;
    countUpStartedAt       = 0;
    resumeAdopt            = false;
    skipBuildingsGate      = false;
    setStep(0);
    /*
      Empty the bars synchronously, so re-opening the overlay for a NEW generation
      shows them empty immediately instead of the previous run's full bars snapping
      back to 0 on the first paced-loop frame.
    */
    if (IS_FRAME) {
      if (genBarFill) {
        genBarFill.style.transition = 'none';
        genBarFill.style.width = '0';
        void genBarFill.offsetWidth; /* reflow so 0 sticks without animating from the old width */
        genBarFill.style.transition = ''; /* restore the CSS .18s transition for the new run */
      }
    } else genSteps.forEach(el => el.style.setProperty('--cf-fill', '0'));
    if (genLabel)  genLabel.textContent  = STAGE_TEXT.area.label;
    if (genDetail) genDetail.textContent = STAGE_TEXT.area.detail;
    startTidbitRotation();
  }

  function showGenerating({ resuming = false } = {}) {
    if (!overlay || !genWrap) return;
    resetGenerating();
    resumeAdopt = !!resuming; /* after the reset, which clears it */
    stopViewsPolling();
    resetExtraViews();
    overlay.style.display = 'flex';
    genWrap.classList.add('is-on');
    if (previewImg) { previewImg.style.display = 'none'; previewImg.removeAttribute('src'); }
    if (stage) stage.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';
    if (metaEl)  metaEl.style.display  = 'none';
    /*
      Steps advance from the API's real progress (applyStage → setTargetProgress),
      eased through the paced display loop so nothing is skipped when warm or quick.
    */
    startProgressLoop();
  }

  function hideGenerating() {
    if (genDeferTimer) { clearTimeout(genDeferTimer); genDeferTimer = null; }
    if (counterRAF)    { cancelAnimationFrame(counterRAF); counterRAF = null; }
    stopProgressLoop();
    stopTidbitRotation();
    if (genWrap) genWrap.classList.remove('is-on');
    if (overlay) {
      overlay.classList.remove('has-ph', 'is-fading-out');
      overlay.style.removeProperty('--cc-gen-ph');
      overlay.style.opacity = '';
      delete overlay.dataset.ph;
    }
  }

  function setBtnLoading(on) {
    btn.disabled = on;
    btn.textContent = on ? (T.generating || 'Generating preview…') : (T.get_btn || 'Generate preview');
  }

  function revealPrice() {
    if (priceBlock) priceBlock.style.display = '';
  }

  function hidePrice() {}

  function showError(msg) {
    hideGenerating();
    if (overlay) overlay.style.display = 'flex';
    if (previewImg) previewImg.style.display = 'none';
    if (metaEl) metaEl.style.display = 'none';
    if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; }
  }

  function clearError() {
    if (errorEl) { errorEl.textContent = ''; errorEl.style.display = 'none'; }
  }

  const stage      = document.getElementById('cube-custom-preview-stage');
  const processing = document.getElementById('cube-custom-processing');
  const processingSub = document.getElementById('cube-custom-processing-sub');
  /*  Sub-line under "Preview is updating…" naming what the render is adding. */
  function setProcessingSub(combo) {
    if (!processingSub) return;
    const CT = window.CF?.T?.cube_custom || {};
    const txt = combo === 'both'    ? (CT.proc_adding_both    || 'Adding trees & streets')
              : combo === 'trees'   ? (CT.proc_adding_trees   || 'Adding trees')
              : combo === 'streets' ? (CT.proc_adding_streets || 'Adding streets')
              : '';
    processingSub.textContent = txt;
    processingSub.hidden = !txt;
  }
  const bgEl       = document.getElementById('cube-custom-preview-bg');
  const galleryWrap     = document.getElementById('cc-v3-gallery');
  const galleryScroll   = document.getElementById('cc-v3-carousel');
  const galleryDots     = document.getElementById('cc-v3-dots');
  const galleryPrevBtn  = document.getElementById('cc-v3-gallery-prev');
  const galleryNextBtn  = document.getElementById('cc-v3-gallery-next');
  const requestViewsBtn = document.getElementById('cc-v3-request-views');
  let viewsRequested = false;
  /*
    Extra gallery views (left / right / back) — slides 1..3. Each: a blurred
    placeholder layer (.cc-view-bg) behind a full image (.cc-view-img) that fades
    in once loaded (slide gets .is-loaded, which also hides its rendering pill).
  */
  const EXTRA_VIEW_SLOTS = ['left', 'right', 'back'];
  const viewSlideEls = {};
  EXTRA_VIEW_SLOTS.forEach((slot) => {
    const slide = document.getElementById('cc-v3-view-' + slot);
    viewSlideEls[slot] = slide ? {
      slide,
      img: slide.querySelector('.cc-view-img'),
      bg: slide.querySelector('.cc-view-bg'),
      stage: 0, /* 0 = empty-frame placeholder, 1 = low-res shown, 2 = full shown */
      reRendering: false, /* combo switch: keep current image, awaiting the new combo's full */
      updating: false, /* reRendering AND confirmed not-ready yet → show the pill */
      startAt: 0, etaAt: 0, /* progress-bar window for this slide's pending render */
    } : null;
  });
  /*  Hide + reset all three extra-view slides back to the frame placeholder. */
  function resetExtraViews() {
    extraViewsRenderStartAt = 0;
    EXTRA_VIEW_SLOTS.forEach((slot) => {
      const v = viewSlideEls[slot];
      if (!v) return;
      v.slide.hidden = true;
      v.slide.classList.remove('is-loaded', 'has-lowres');
      v.stage = 0; v.updating = false; v.reRendering = false;
      if (v.img) { v.img.removeAttribute('src'); v.img.removeAttribute('data-img-full'); }
      if (v.bg) v.bg.style.backgroundImage = '';
    });
  }
  /*
    Reveal the three slides in their starting state: the static empty-frame
    placeholder (CSS layer) + the "Rendering…" overlay, until each angle lands.
  */
  function revealExtraViews() {
    EXTRA_VIEW_SLOTS.forEach((slot) => {
      const v = viewSlideEls[slot];
      if (!v) return;
      v.slide.hidden = false;
      v.slide.classList.remove('is-loaded', 'has-lowres');
      v.stage = 0; v.updating = false; v.reRendering = false;
      if (v.img) v.img.removeAttribute('src');
      if (v.bg) v.bg.style.backgroundImage = '';
    });
  }
  /*
    Advance a slide through its stages — frame → low-res → full — ONCE each.
    Gated on a numeric stage, NEVER on the URL string: /views re-signs the URLs
    every poll (the query string changes), so comparing src would re-set the
    image each cycle and make it reload (the flicker). The stage flag prevents that.
  */
  function applyExtraView(slot, ph, full, ready) {
    const v = viewSlideEls[slot];
    if (!v) return;
    /*
      Combo switch: keep the current sharp image on screen and swap to the new
      combo's full once it's ready — no blurred low-res, no clearing. The
      "Preview is updating…" pill is shown ONLY if a poll confirms the new view
      isn't ready yet, so an already-rendered (cached) combo swaps in with no pill.
    */
    if (v.reRendering) {
      if (ready && full) {
        const pre = new Image(); pre.decoding = 'async';
        const show = () => {
          if (!v.img) return;
          v.img.src = full; v.img.dataset.imgFull = full;
          v.reRendering = false; v.updating = false;
          updateProcessingChip(); /* its pill hides once this slide resolves */
        };
        pre.onload = show; pre.onerror = show; pre.src = full;
        if (pre.complete) show();
      } else if (!v.updating) {
        v.updating = true; /* confirmed not-ready → now show the pill */
        updateProcessingChip();
      }
      return;
    }
    if (ph && v.stage < 1) { /* low-res landed → blurred layer fades in */
      if (v.bg) v.bg.style.backgroundImage = `url("${ph}")`;
      v.slide.classList.add('has-lowres');
      v.stage = 1;
    }
    if (ready && full && v.stage < 2) { /* full ready → sharp image fades in, overlay hides */
      v.stage = 2;
      const pre = new Image();
      pre.decoding = 'async';
      const show = () => {
        if (!v.img) return;
        v.img.src = full;
        v.img.dataset.imgFull = full; /* magnifier zoom uses the full-res */
        v.slide.classList.add('is-loaded');
        updateProcessingChip(); /* fresh view resolved → hide/advance the pill */
      };
      pre.onload = show; pre.onerror = show;
      pre.src = full;
      if (pre.complete) show();
    }
  }
  /*
    Combo switch: each slide that already shows a full image keeps it and is
    flagged "reRendering" (await the new combo's full; the "Preview is updating…"
    pill only appears if a poll confirms it isn't ready). Slides not yet rendered
    fall back to the render overlay for the new combo.
  */
  function markExtraViewsReRendering() {
    /*
      The new combo's extra views render on demand from now, current slide FIRST
      (see #first), then the others — each ~6s. Each slide's progress-bar ETA is
      its position in that render order.
    */
    const switchAt = Date.now();
    const first = visibleExtraSlot();
    const order = first
      ? [first, ...EXTRA_VIEW_SLOTS.filter((s) => s !== first)]
      : EXTRA_VIEW_SLOTS.slice();
    EXTRA_VIEW_SLOTS.forEach((slot) => {
      const v = viewSlideEls[slot];
      if (!v) return;
      if (v.stage === 2) {
        v.reRendering = true; v.updating = false; /* has an image → keep it, await new full */
        v.startAt = switchAt;
        v.etaAt = switchAt + (order.indexOf(slot) + 1) * RENDER_MS;
      } else {
        v.slide.hidden = false;
        v.slide.classList.remove('is-loaded', 'has-lowres');
        v.stage = 0; v.updating = false; v.reRendering = false;
        if (v.img) v.img.removeAttribute('src');
        if (v.bg) v.bg.style.backgroundImage = '';
      }
    });
  }

  let currentDesignId = null;
  let currentCombo = 'model';

  const creditsByDesign = {};
  /*
    The preview server's credits, as stored with each design: a <p> per source under a "Geodata sources for this
    model" heading, each source's own attribution text followed by a link to its license. Under the cards they
    follow "Credits:" as one line, so: the heading goes (the label says it); a license the attribution already
    names ("(ODbL)", "dl-de/by-2-0", "CC BY 4.0") becomes the link in place, in the source's own wording, instead
    of being named a second time after it; the OSM sources that only pass OSM's data on (the Geofabrik extract,
    the coastline polygons) give OSM's own credit, so it is given once; and the links open in a new tab, leaving
    the configurator where it was. Done here because the HTML was stored when each design was made.
  */
  const OSM_CREDIT = '© OpenStreetMap contributors (ODbL)';
  function licenseIn(text, label) {
    const chars = label.toLowerCase().replace(/[^a-z0-9]/g, '').split('');
    if (!chars.length) return null;
    const re = new RegExp('(?<![a-z0-9])' + chars.join('[\\s\\-/.]*') + '(?![a-z0-9])', 'gi');
    let m, last = null;
    while ((m = re.exec(text))) last = m;
    return last;
  }
  function tidyCredits(html) {
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    const seen = new Set();
    const out = [];
    tpl.content.querySelectorAll('p').forEach((p) => {
      const links = [...p.querySelectorAll('a')];
      let text = '';
      for (const n of p.childNodes) { if (n.nodeName === 'A') break; text += n.textContent; }
      text = text.replace(/\s+/g, ' ').trim();
      if (!text || (!links.length && text === 'Geodata sources for this model')) return;
      if (text.endsWith(' ' + OSM_CREDIT)) text = OSM_CREDIT;
      const q = document.createElement('p');
      const rest = [];
      let placed = false;
      for (const a of links) {
        a.target = '_blank';
        a.rel = 'noopener';
        const m = !placed && licenseIn(text, a.textContent);
        if (m) {
          placed = true;
          a.textContent = m[0];
          q.append(text.slice(0, m.index), a, text.slice(m.index + m[0].length));
        } else rest.push(a);
      }
      if (!placed) q.append(text);
      rest.forEach((a) => q.append(' ', a));
      const key = q.innerHTML;
      if (seen.has(key)) return;
      seen.add(key);
      out.push(q.outerHTML);
    });
    return out.join('\n');
  }
  function renderDataCredits(creditHtml) {
    const box = document.getElementById('cc-data-credits');
    const txt = document.getElementById('cc-data-credits-text');
    if (!box || !txt) return;
    const html = tidyCredits((creditHtml || '').trim());
    if (html) { txt.innerHTML = html; box.hidden = false; }
    else      { txt.innerHTML = ''; box.hidden = true; }
  }
  async function fetchCreditsFor(designId) {
    if (!API_URL || !designId || designId in creditsByDesign) return;
    try {
      const data = await getPreviewData(designId);
      if (!data || data.status !== 'ready') return;
      creditsByDesign[designId] = data.credits_attributable_html || '';
      if (currentDesignId === designId) renderDataCredits(creditsByDesign[designId]);
    } catch (_) { }
  }
  function showDataCredits(designId, result) {
    if (!designId) { renderDataCredits(''); return; }
    if (result && typeof result === 'object' && result.credits_attributable_html !== undefined) {
      creditsByDesign[designId] = result.credits_attributable_html || '';
    }
    if (designId in creditsByDesign) renderDataCredits(creditsByDesign[designId]);
    else { renderDataCredits(''); fetchCreditsFor(designId); }
  }

  let overlayFadeTimer = null;
  /*
    Cross-fade the loading overlay (blur placeholder + spinner) out to reveal the
    finished hero underneath. Holds the blur until the sharp hero has decoded so
    we never flash a blank frame, then fades — see the CSS opacity transition.
  */
  function fadeOutOverlayToHero(heroUrl) {
    if (!overlay) return;
    const finish = () => {
      if (overlayFadeTimer) { clearTimeout(overlayFadeTimer); overlayFadeTimer = null; }
      overlay.removeEventListener('transitionend', onEnd);
      overlay.style.display = 'none';
      hideGenerating(); /* strips has-ph / is-fading-out + clears timers AFTER the fade */
    };
    const onEnd = (e) => {
      if (e.target === overlay && e.propertyName === 'opacity') finish();
    };
    const startFade = () => {
      overlay.addEventListener('transitionend', onEnd);
      overlay.classList.add('is-fading-out');
      overlayFadeTimer = setTimeout(finish, 750);
    };
    const pre = new Image();
    pre.decoding = 'async';
    const go = () => requestAnimationFrame(startFade);
    pre.onload = go; pre.onerror = go;
    pre.src = heroUrl;
    if (pre.complete) go();
  }

  function showOverlay(result, cached, elapsedS) {
    if (!previewImg) return;
    const url = (typeof result === 'object' && result) ? result.preview_url : result;
    const designId = (typeof result === 'object' && result) ? result.design_id : null;
    if (designId !== currentDesignId) {
      stopViewsPolling();
      resetExtraViews();
    }
    currentDesignId = designId;
    window.CF.MARKER?.onDesign?.(designId);
    loadComboData(designId, result);
    showDataCredits(designId, result); /* fill the credits under the preview */
    /*
      Cross-fade only when the loading overlay is actually on screen (a real
      render wait); instant/cached results just snap in with no overlay shown.
    */
    const crossfade = !!(url && overlay && overlay.style.display !== 'none');
    if (url) {
      currentCombo = comboKey(); /* 'model' unless the shopper later toggles */
      comboPendingCombo = comboPreviews[currentCombo] ? null : currentCombo;
      const heroUrl = comboPreviews[currentCombo] || url;
      setHeroImage(heroUrl, heroUrl); /* slide-1 hero only — no turntable yet */
      updateProcessingChip();
      persistComboOnPreview();
    }
    previewImg.style.display = 'block';
    if (stage) stage.style.display = '';
    if (crossfade) {
      fadeOutOverlayToHero(comboPreviews[currentCombo] || url);
    } else {
      hideGenerating();
      if (overlay) overlay.style.display = 'none';
    }
    clearError();
    if (metaEl) metaEl.style.display = 'none';

    collapseToHero();
    if (designId && comboPendingCombo) startComboHeroPoll(designId);
  }

  function hideOverlay() {
    hideGenerating();
    stopViewsPolling();
    viewsRequested = false;
    resetExtraViews();
    if (galleryWrap) galleryWrap.setAttribute('data-views-requested', 'false');
    if (requestViewsBtn) requestViewsBtn.hidden = true;
    setSingleImageMode(true);
    renderDataCredits(''); /* no design shown → clear the source credits */
    if (overlay) overlay.style.display = 'none';
    if (stage) stage.style.display = 'none';
    if (previewImg) {
      previewImg.style.display = 'none';
      previewImg.removeAttribute('src');
      previewImg.removeAttribute('data-img-preview');
      previewImg.removeAttribute('data-img-full');
    }
    if (errorEl) errorEl.style.display = 'none';
    if (metaEl) metaEl.style.display = 'none';
  }

  function setHeroImage(url, full) {
    if (!previewImg || !url) return;
    const fullUrl = full || url;
    if (previewImg.src !== url) {
      const previousUrl = previewImg.currentSrc || previewImg.src;
      if (bgEl && previousUrl) bgEl.style.backgroundImage = `url("${previousUrl}")`;
      previewImg.src = url;
      previewImg.dataset.imgPreview = url;
    }
    previewImg.dataset.imgFull = fullUrl;
  }

  const RENDER_MS = IS_FRAME ? 21000 : 6000; /* measured: one CUBE render; one FRAME view (1800²@6 spp) */
  let secondaryRenderStartAt = 0; /* when the trees→streets→both queue started (gen-ready) */
  let progressRunning = false;
  let progressEtaAt = 0; /* absolute timestamp the current bar fills toward */
  let progressDoneTimer = null;
  let progressCreepTimer = null; /* slow post-ETA creep so the bar never freezes at its target */
  const ADDON_RENDER_MS = IS_FRAME ? 30000 : 14000; /* step-3 add-on = TWO views (top + flat) + composite — slower than one hero */
  /*
    Timed-estimate progress bar inside the "Preview is updating…" pill. It targets
    an ABSOLUTE completion estimate (etaAt = render-start + queue-position × RENDER_MS),
    so a combo that started rendering earlier shows the bar already part-filled,
    and a later combo in the queue (e.g. streets behind trees) gets a longer bar.
    Snaps to 100% the moment the image actually arrives.
  */
  function setProgressBar(on, startAt, etaAt) {
    if (!processing) return;
    const fill = processing.querySelector('.cc-v3-processing__fill');
    if (!fill) return;
    if (progressCreepTimer) { clearTimeout(progressCreepTimer); progressCreepTimer = null; }
    if (on) {
      if (progressRunning && progressEtaAt === etaAt) return;
      progressRunning = true; progressEtaAt = etaAt;
      if (progressDoneTimer) { clearTimeout(progressDoneTimer); progressDoneTimer = null; }
      const now = Date.now();
      const total = Math.max(1, etaAt - startAt);
      const frac = Math.min(0.8, Math.max(0, (now - startAt) / total));
      const remaining = Math.max(0.3, (etaAt - now) / 1000);
      fill.style.transition = 'none'; fill.style.width = (frac * 100) + '%';
      void fill.offsetWidth; /* reflow so the start sticks */
      fill.style.transition = `width ${remaining}s ease-out`;
      fill.style.width = '82%';
      /*
        Never STALL: renders often run slower than the estimate (terrain, or a busy
        addon queue), and a bar frozen at its target reads as broken. Once the ETA
        elapses, keep creeping slowly toward 96% so it always shows life; the real
        image arrival still snaps it to 100% (the `off` branch below).
      */
      progressCreepTimer = setTimeout(() => {
        fill.style.transition = 'width 50s linear';
        fill.style.width = '96%';
      }, remaining * 1000);
    } else if (progressRunning) {
      progressRunning = false; progressEtaAt = 0;
      fill.style.transition = 'width 220ms ease';
      fill.style.width = '100%';
      progressDoneTimer = setTimeout(() => {
        fill.style.transition = 'none'; fill.style.width = '0%';
      }, 260);
    }
  }
  /*
    Extra views render on demand (left→right→back, ~6s each). Anchor every still-
    rendering slide's ETA window to when that render started; a slide reached later
    in the queue — or on re-entry — shows a part-filled bar (the shared pill reads
    v.startAt/v.etaAt), rather than restarting from zero.
  */
  let extraViewsRenderStartAt = 0;
  function anchorExtraViewEtas() {
    const startAt = extraViewsRenderStartAt || (extraViewsRenderStartAt = Date.now());
    EXTRA_VIEW_SLOTS.forEach((slot, i) => {
      const v = viewSlideEls[slot];
      if (!v || v.stage === 2) return;
      v.startAt = startAt;
      v.etaAt = startAt + (i + 1) * RENDER_MS; /* 1-based position in the render queue */
    });
  }
  /*  The visible gallery slot: null = hero (slide 0); else 'left'/'right'/'back'. */
  function visibleExtraSlot() {
    const idx = currentGalleryIndex();
    return idx >= 1 ? EXTRA_VIEW_SLOTS[idx - 1] : null;
  }
  /*
    A combo hero's completion estimate: render-start (gen-ready) + its 1-based
    position in the trees→streets→both render queue × ~6s.
  */
  function heroEtaFor(combo) {
    const order = secondaryComboOrder();
    const pos = order.indexOf(combo);
    return (secondaryRenderStartAt || Date.now()) + (pos < 0 ? 1 : pos + 1) * RENDER_MS;
  }
  /*
    Show the "Preview is updating…" pill only when the VISIBLE slide is waiting on
    the current combo — the hero (its combo image pending) or an extra slide mid
    combo-switch. Brand-new, never-rendered views use their own render overlay.
  */
  function updateProcessingChip() {
    if (!processing) return;
    const slot = visibleExtraSlot();
    if (slot) {
      const v = viewSlideEls[slot];
      /*
        Show the pill for a combo-switch re-render (v.updating) OR a freshly
        requested extra view that hasn't finished its first render (stage < 2).
      */
      if (v && (v.updating || (viewsRequested && v.stage < 2))) {
        processing.classList.add('is-visible');
        setProcessingSub(v.updating ? currentCombo : ''); /* combo-switch names the combo; fresh view stays generic */
        setProgressBar(true, v.startAt || Date.now(), v.etaAt || (Date.now() + RENDER_MS));
        return;
      }
    } else if (comboPendingCombo && comboPendingCombo === currentCombo) {
      processing.classList.add('is-visible');
      setProcessingSub(comboPendingCombo);
      setProgressBar(true, secondaryRenderStartAt || Date.now(), heroEtaFor(comboPendingCombo));
      return;
    }
    processing.classList.remove('is-visible');
    setProgressBar(false);
    setProcessingSub('');
  }

  const treesBtnWrap   = document.getElementById('option-button-trees');
  const streetsBtnWrap = document.getElementById('option-button-streets');
  let comboPreviews   = { model: null }; /* {combo: hero URL} from the /preview ready payload */
  let comboHasTrees   = false;
  let comboHasStreets = false;
  let treesOn   = false;
  let streetsOn = false;
  let comboPendingCombo = null;
  /*
    Config to restore once real combo availability is known (set on design open;
    holds {trees,streets,cover,plaque,plaque_headline,plaque_subheadline}).
  */
  let pendingRestore = null;
  const COMBO_HERO_POLL_MS = 1500;
  /*
    Apply the cover/plaque parts of a restored config (independent of combo data).
    Uses the global setDisplayCover/setPlaque so the DOM + cart state both update.
  */
  function cfApplyCoverPlaque(cfg) {
    if (!cfg) return;
    try {
      /*
        The FRAME has no display cover (2026-07-23): always 'none', so a restored design never carries an
        acrylic/glass cover (no UI, no cart line, no price contribution).
      */
      const cover = !IS_FRAME && ['none', 'acrylic', 'glass'].includes(cfg.cover) ? cfg.cover : 'none';
      if (typeof setDisplayCover === 'function') setDisplayCover(cover);
    } catch (_) {}
    try {
      const mat = (cfg.plaque === 'steel' || cfg.plaque === 'brass') ? cfg.plaque : null;
      if (mat && window.CF.STATE) window.CF.STATE.plaqueMaterial = mat;
      if (typeof setPlaque === 'function') setPlaque(mat || 'none');
      const h = document.getElementById('plaque-note-1');
      const s = document.getElementById('plaque-subnote-1');
      if (h) h.value = cfg.plaque_headline || '';
      if (s) s.value = cfg.plaque_subheadline || '';
      /*  The gallery's plaque and the buy box's rows follow (2026-10-31: rows, no accordions to open). */
      if (typeof updatePlaqueModalPreview === 'function') updatePlaqueModalPreview(1);
    } catch (_) {}
  }

  function comboKey() {
    if (treesOn && streetsOn) return 'both';
    if (treesOn)   return 'trees';
    if (streetsOn) return 'streets';
    return 'model';
  }

  function syncComboButtons() {
    if (treesBtnWrap) {
      treesBtnWrap.classList.toggle('is-disabled', !comboHasTrees);
      treesBtnWrap.classList.toggle('active', treesOn && comboHasTrees);
    }
    if (streetsBtnWrap) {
      streetsBtnWrap.classList.toggle('is-disabled', !comboHasStreets);
      streetsBtnWrap.classList.toggle('active', streetsOn && comboHasStreets);
    }
  }
  /*
    Toggle the max-height guard (blocks the step-3 button + shows the warning)
    from a design's printed height. Acts only when the height is known, so it
    fires on BOTH fresh generations AND restored ("View your designs") designs —
    the latter reaches here via fetchComboDataFor's /preview payload.
  */
  function applyHeightGuard(mm) {
    if (typeof mm !== 'number') return;
    if (root) root.classList.toggle('is-height-exceeded', mm > 150);
  }

  function applyComboData(data, opts) {
    applyHeightGuard(data && data.model_height_mm);
    /*  A restored design arrives without its height; keep it for the add-to-cart box choice. */
    const shown = window.CF_CUBE_CUSTOM_PREVIEW;
    if (shown && data && data.design_id === shown.design_id && typeof data.model_height_mm === 'number') {
      shown.model_height_mm = data.model_height_mm;
    }
    comboPreviews   = (data && data.previews) || { model: (data && data.preview_url) || null };
    comboHasTrees   = !!(data && data.has_trees);
    comboHasStreets = !!(data && data.has_streets);
    treesOn = false; streetsOn = false; currentCombo = 'model';
    comboPendingCombo = null;
    /*
      Restore selections only once REAL combo availability is known (applyView =
      the fetched /preview payload) AND only from an EXPLICIT pendingRestore (set
      when the shopper OPENS a saved design). We deliberately do NOT fall back to
      the design's stored config here: design_id is shared across shoppers, so a
      fresh generate of an already-configured geometry would otherwise inherit
      another shopper's selections (incl. plaque text). Clamp to what's available.
    */
    if (opts && opts.applyView) {
      const cfg = pendingRestore;
      if (cfg) {
        treesOn   = !!cfg.trees   && comboHasTrees;
        streetsOn = !!cfg.streets && comboHasStreets;
        cfApplyCoverPlaque(cfg);
      }
      pendingRestore = null;
    }
    syncComboButtons();
    persistComboOnPreview();
    preloadComboHeroes(); /* warm the available hero images so switching is instant */
    if (currentDesignId) startComboHeroPoll(currentDesignId);
    if (opts && opts.applyView) applyDefaultCombo();
  }

  function loadComboData(designId, result) {
    if (result && typeof result === 'object' && result.previews) {
      applyComboData(result);
    } else {
      applyComboData({ previews: { model: (result && result.preview_url) || null } });
      fetchComboDataFor(designId);
    }
  }
  async function fetchComboDataFor(designId) {
    if (!API_URL || !designId) return;
    try {
      const data = await getPreviewData(designId);
      if (!data || data.status !== 'ready' || currentDesignId !== designId) return;
      applyComboData(data, { applyView: true });
    } catch (_) { }
  }

  function applicableComboList() {
    const list = ['model'];
    if (comboHasTrees)   list.push('trees');
    if (comboHasTrees && comboHasStreets) list.push('both');
    if (comboHasStreets) list.push('streets');
    return list;
  }
  /*
    The secondary heroes render in this order (trees → both → streets), so a
    combo's hero ETA = render-start + (its 1-based position here) × ~6s. This
    MUST match _applicable_combos() in pipeline/job_runner.py.
  */
  function secondaryComboOrder() {
    const order = [];
    if (comboHasTrees)   order.push('trees');
    if (comboHasTrees && comboHasStreets) order.push('both');
    if (comboHasStreets) order.push('streets');
    return order;
  }
  function allCombosReady() {
    return applicableComboList().every((c) => !!comboPreviews[c]);
  }

  let comboHeroPollTimer    = null;
  let comboHeroPollDesignId = null;
  let comboHeroPollDeadline = 0;
  function stopComboHeroPoll() {
    if (comboHeroPollTimer) { clearTimeout(comboHeroPollTimer); comboHeroPollTimer = null; }
    comboHeroPollDesignId = null;
  }
  function startComboHeroPoll(designId) {
    if (!API_URL || !designId || allCombosReady()) return;
    if (comboHeroPollDesignId === designId && comboHeroPollTimer) return;
    stopComboHeroPoll();
    comboHeroPollDesignId = designId;
    /*
      No-progress timeout: stop polling if no new combo hero arrives for ~90s
      (reset below whenever one does). Prevents a perpetual "loading" state when
      a design's background render was cancelled and never produces all its
      combo heroes — without cutting off a slow-but-progressing render.
    */
    comboHeroPollDeadline = Date.now() + 90000;
    const tick = async () => {
      if (comboHeroPollDesignId !== designId || currentDesignId !== designId) {
        stopComboHeroPoll();
        return;
      }
      if (Date.now() > comboHeroPollDeadline) { stopComboHeroPoll(); updateProcessingChip(); return; }
      try {
        const res = await fetch(`${API_URL}/preview/${encodeURIComponent(designId)}`);
        if (res.ok) {
          const data = await res.json();
          if (data.status === 'ready' && currentDesignId === designId && data.previews) {
            let added = false;
            Object.keys(data.previews).forEach((c) => {
              if (data.previews[c] && !comboPreviews[c]) { comboPreviews[c] = data.previews[c]; added = true; }
            });
            if (added) {
              comboHeroPollDeadline = Date.now() + 90000;
              preloadComboHeroes();
              if (comboPendingCombo && comboPreviews[comboPendingCombo] && comboPendingCombo === currentCombo) {
                const c = comboPendingCombo;
                comboPendingCombo = null;
                showCombo(c);
              }
              updateProcessingChip();
            }
          }
        }
      } catch (_) { }
      if (comboHeroPollDesignId === designId && !allCombosReady()) {
        comboHeroPollTimer = setTimeout(tick, COMBO_HERO_POLL_MS);
      } else {
        stopComboHeroPoll();
      }
    };
    comboHeroPollTimer = setTimeout(tick, COMBO_HERO_POLL_MS);
  }

  function persistComboOnPreview() {
    const p = window.CF_CUBE_CUSTOM_PREVIEW;
    if (p && p.design_id === currentDesignId) {
      p.trees   = treesOn   && comboHasTrees;
      p.streets = streetsOn && comboHasStreets;
    }
  }
  /*
    Kick off the THREE extra views (left/right/back) for a combo. Works for any
    combo INCLUDING model now (the turntable is gone — even the model's extra
    views render on demand). The render is resumable + sequential server-side.
    `first` (optional) = a view name (left/right/back) to render BEFORE the others,
    so the slide the shopper is looking at fills in first.
  */
  async function triggerCarouselRender(designId, combo, first) {
    if (!API_URL || !designId) return;
    try {
      let url = `${API_URL}/preview/${encodeURIComponent(designId)}/carousel?combo=${encodeURIComponent(combo)}${markerParam(designId)}`;
      if (first) url += `&first=${encodeURIComponent(first)}`;
      await fetch(url, { method: 'POST' });
    } catch (_) { }
  }
  /*
    The location marker (assets/cc-location-marker.js), while it is on: the extra views come with it in, rendered
    onto the design's own views (Alex, 2026-10-30), and until each lands the design's own shows behind it.
  */
  function markerParam(designId) {
    const m = window.CF.MARKER?.current?.(designId);
    return m && m.on && m.key ? `&marker=${encodeURIComponent(m.key)}` : '';
  }

  function preloadComboHeroes() {
    Object.keys(comboPreviews || {}).forEach((c) => {
      const u = comboPreviews[c];
      if (!u) return;
      const img = new Image();
      img.decoding = 'async';
      img.src = u;
      if (typeof img.decode === 'function') img.decode().catch(() => {});
    });
  }

  function showCombo(combo) {
    if (!currentDesignId) return;
    currentCombo = combo;
    persistComboOnPreview();
    const ready   = !!comboPreviews[combo];
    comboPendingCombo = ready ? null : combo;
    const heroUrl = comboPreviews[combo] || comboPreviews.model;
    if (heroUrl) setHeroImage(heroUrl, heroUrl); /* slide-0 hero always reflects the combo */
    window.CF.MARKER?.onCombo?.(currentDesignId, combo); /* …or its location marker's picture */
    updateProcessingChip();

    stopViewsPolling();
    /*
      Extra views are per-combo. If they were already requested, KEEP each
      rendered slide's current image (swap in the new combo's as it lands; the
      "Preview is updating…" pill shows only while a slide is genuinely waiting).
      Render the slide the shopper is on FIRST, then the others, for this combo.
    */
    if (viewsRequested) {
      markExtraViewsReRendering();
      updateProcessingChip();
      if (ready) {
        triggerCarouselRender(currentDesignId, combo, visibleExtraSlot());
        startViewsPolling(currentDesignId, combo);
      } else {
        startComboHeroPoll(currentDesignId); /* hero pending → re-runs showCombo once ready */
      }
    } else if (!ready) {
      startComboHeroPoll(currentDesignId); /* keep the hero resolving even while gated */
    }
  }

  function selectCombo(next) {
    if (!currentDesignId || next === currentCombo) return;
    showCombo(next);
  }

  function setSingleImageMode(on) {
    [galleryDots, galleryPrevBtn, galleryNextBtn].forEach((el) => {
      if (el) el.classList.toggle('single-image', !!on);
    });
  }

  function gallerySlideEls() {
    return galleryScroll
      ? Array.from(galleryScroll.querySelectorAll('.cc_city-preview-wrapper:not([hidden])'))
      : [];
  }

  function currentGalleryIndex() {
    const slides = gallerySlideEls();
    if (!galleryScroll || !slides.length) return 0;
    return slides.reduce((best, s, i) => {
      const d = Math.abs((s.offsetLeft - galleryScroll.offsetLeft) - galleryScroll.scrollLeft);
      return d < best.d ? { i, d } : best;
    }, { i: 0, d: Infinity }).i;
  }

  function updateGalleryDots(forceIndex) {
    if (!galleryDots) return;
    const idx = (typeof forceIndex === 'number') ? forceIndex : currentGalleryIndex();
    const visible = gallerySlideEls().length;
    Array.from(galleryDots.querySelectorAll('button')).forEach((dot, i) => {
      dot.hidden = i >= visible;
      dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
  }
  /*
    Position-aware arrows (same pattern as cc_configurator): grey + no-op the
    prev button at the first slide and the next button at the last, by toggling
    `.is-at-limit` from the scroll position. The scrollToSlide clamp already
    makes clicks at the limit no-ops; this just reflects it visually.
  */
  function updateGalleryNavLimits() {
    if (!galleryScroll) return;
    const maxScroll = galleryScroll.scrollWidth - galleryScroll.clientWidth;
    const sl = galleryScroll.scrollLeft;
    if (galleryPrevBtn) galleryPrevBtn.classList.toggle('is-at-limit', sl <= 5);
    if (galleryNextBtn) galleryNextBtn.classList.toggle('is-at-limit', sl >= maxScroll - 5);
  }

  function scrollGalleryToSlide(index, smooth) {
    const slides = gallerySlideEls();
    if (!galleryScroll || !slides.length) return;
    const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
    galleryScroll.scrollTo({
      left: target.offsetLeft - galleryScroll.offsetLeft,
      behavior: smooth ? 'smooth' : 'auto',
    });
    updateGalleryDots(index);
    updateGalleryNavLimits();
  }

  function collapseToHero() {
    viewsRequested = false;
    stopViewsPolling();
    resetExtraViews();
    if (galleryWrap) galleryWrap.setAttribute('data-views-requested', 'false');
    setSingleImageMode(true);
    if (requestViewsBtn) requestViewsBtn.hidden = !currentDesignId;
    scrollGalleryToSlide(0, false);
  }

  function requestAdditionalViews() {
    if (!currentDesignId || viewsRequested) return;
    viewsRequested = true;
    if (requestViewsBtn) requestViewsBtn.hidden = true;
    if (galleryWrap) galleryWrap.setAttribute('data-views-requested', 'true');
    revealExtraViews(); /* 3 slides appear in their "rendering" state */
    setSingleImageMode(false); /* 4 slides now → show dots/arrows */
    extraViewsRenderStartAt = Date.now(); /* render starts now → anchor each slide's ETA window */
    anchorExtraViewEtas(); /* set per-slide start/eta for the "Preview is updating" pill */
    triggerCarouselRender(currentDesignId, currentCombo);
    startViewsPolling(currentDesignId, currentCombo);
    requestAnimationFrame(() => { scrollGalleryToSlide(1, true); updateProcessingChip(); });
  }

  if (requestViewsBtn) requestViewsBtn.addEventListener('click', requestAdditionalViews);
  if (galleryPrevBtn) galleryPrevBtn.addEventListener('click', (e) => {
    e.preventDefault(); scrollGalleryToSlide(currentGalleryIndex() - 1, true);
  });
  if (galleryNextBtn) galleryNextBtn.addEventListener('click', (e) => {
    e.preventDefault(); scrollGalleryToSlide(currentGalleryIndex() + 1, true);
  });
  if (galleryScroll) galleryScroll.addEventListener('scroll', () => {
    requestAnimationFrame(() => { updateGalleryDots(); updateGalleryNavLimits(); updateProcessingChip(); });
  }, { passive: true });
  if (galleryDots) Array.from(galleryDots.querySelectorAll('button')).forEach((dot, i) => {
    dot.addEventListener('click', () => scrollGalleryToSlide(i, true));
  });

  function applyDefaultCombo() {
    const def = comboKey();
    if (currentDesignId && def !== currentCombo) showCombo(def);
  }

  if (treesBtnWrap) {
    treesBtnWrap.addEventListener('click', () => {
      if (!comboHasTrees || !currentDesignId) return;
      window.CF.markOptionTried?.(currentDesignId, 'trees');
      treesOn = !treesOn;
      syncComboButtons();
      selectCombo(comboKey());
      window.CF.persistDesignConfig?.();
    });
  }
  if (streetsBtnWrap) {
    streetsBtnWrap.addEventListener('click', () => {
      if (!comboHasStreets || !currentDesignId) return;
      window.CF.markOptionTried?.(currentDesignId, 'streets');
      streetsOn = !streetsOn;
      syncComboButtons();
      selectCombo(comboKey());
      window.CF.persistDesignConfig?.();
    });
  }

  let viewsPollTimer    = null;
  let viewsPollDesignId = null;
  let viewsPollCombo    = 'model';
  let viewsStableCount  = 0;

  function startViewsPolling(designId, combo) {
    stopViewsPolling();
    combo = combo || 'model';
    viewsPollDesignId = designId;
    viewsPollCombo = combo;
    viewsStableCount = 0;
    let lastReady = -1;
    const qs = `?combo=${encodeURIComponent(combo)}${markerParam(designId)}`;
    const tick = async () => {
      if (viewsPollDesignId !== designId || viewsPollCombo !== combo) return;
      try {
        const res = await fetch(`${API_URL}/preview/${designId}/views${qs}`);
        if (!res.ok) throw new Error(`views ${res.status}`);
        const data = await res.json();
        if (viewsPollDesignId !== designId || viewsPollCombo !== combo) return;
        let readyCount = 0;
        for (const v of (data.views || [])) {
          if (!v || !v.name) continue;
          applyExtraView(v.name, v.ph, v.full, v.ready);
          if (v.ready) readyCount += 1;
        }
        const total = data.total || EXTRA_VIEW_SLOTS.length;
        if (readyCount >= total) { stopViewsPolling(); return; }
        /*
          Stop if no new view completes for a long stretch (a render is sequential
          and slow, so be patient — ~300 s of no progress before giving up).
        */
        viewsStableCount = (readyCount === lastReady) ? viewsStableCount + 1 : 0;
        lastReady = readyCount;
        if (viewsStableCount >= 200) { stopViewsPolling(); return; }
      } catch (_exc) {
        viewsStableCount += 1;
        if (viewsStableCount >= 200) { stopViewsPolling(); return; }
      }
      viewsPollTimer = setTimeout(tick, 1500);
    };
    tick();
  }

  function stopViewsPolling() {
    if (viewsPollTimer) { clearTimeout(viewsPollTimer); viewsPollTimer = null; }
    viewsPollDesignId = null;
    viewsPollCombo = 'model';
  }

  window.CF_CUBE_CUSTOM_PREVIEW = null;

  const POLL_INTERVAL_MS  = 1500; /* snappy updates for ~30s warm renders */
  const GEN_OVERLAY_DELAY = 250; /* skip the overlay flash if the warmed preview returns instantly */
  /*
    How long the INLINE watcher waits before showing "taking longer than
    expected". Cold jobs (queue + render) run several minutes; a cold FRAME is a
    DAG of 11 queued jobs, so 10 min falsely errored on healthy builds. Giving up here is
    deliberate — the shopper shouldn't stare at a spinner forever — and the
    cross-page notifier keeps watching to its own, strictly LARGER MAX_AGE
    (snippets/cf-design-notify), so a design that finishes after this still toasts.
  */
  const POLL_TIMEOUT_MS   = 20 * 60 * 1000;
  let pollTimer = null;
  let polling   = false;
  let previewRunId = 0;
  let lastRenderDesignId = null;

  if (changeBtn) {
    changeBtn.addEventListener('click', () => {
      previewRunId += 1;
      /*
        Stop WATCHING the render — never cancel it. This used to POST /cancel for
        the in-flight design, so a shopper who came back to a still-generating
        design and then touched "Change location" killed the very job they were
        waiting for, while the notifier kept polling the corpse and showing
        "Generating…" until it aged out. Leaving the map is not a decision to
        throw the render away; only the × on a gallery card cancels (removeDesign).
      */
      lastRenderDesignId = null;
      stopPolling();
      setBtnLoading(false);
      hideOverlay();
      hidePrice();
      if (root) root.classList.remove('is-preview-ready');
      window.CF_CUBE_CUSTOM_PREVIEW = null;
      setConfiguratorView('location');
      document.getElementById('cube-custom-configurator')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function stopPolling() {
    polling = false;
    if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; }
  }

  function onReady(data, runId) {
    if (runId !== previewRunId) return;
    stopPolling();
    /*  Shown inline here → drop it from the cross-page notifier so it never toasts. */
    window.CF_NOTIFY?.clear(data.design_id);
    setBtnLoading(false);
    /*
      Generation just finished → the secondary combo heroes (trees → streets →
      both) start rendering now, sequentially. The "Preview is updating…" bar
      measures its ETA from here, not from when a combo button is clicked.
    */
    secondaryRenderStartAt = Date.now();
    lastRenderDesignId = data.design_id;
    const _place = window.CF_CUBE_CUSTOM_MAP?.getState?.() || {};
    const finished = { design_id: data.design_id, preview_url: data.preview_url, model_height_mm: data.model_height_mm,
      city: _place.city || '', area: _place.area || '', country: _place.country || '' };
    /*
      Only when the message carries them. The poll's "ready" answer does not, and caching '' for it meant
      showDataCredits found an entry, never fetched the design's record, and left the credits blank on a
      freshly made design — they only appeared when the same design was reopened from "Your designs".
    */
    if (typeof data.credits_attributable_html === 'string') creditsByDesign[data.design_id] = data.credits_attributable_html;

    const viewing = window.CF_CUBE_CUSTOM_PREVIEW;
    if (viewing && viewing.design_id && viewing.design_id !== data.design_id) {
      document.dispatchEvent(new CustomEvent('cf:cube:preview-ready', { detail: finished }));
      return;
    }

    revealPrice();
    window.CF_CUBE_CUSTOM_PREVIEW = finished;
    if (root) root.classList.add('is-preview-ready');
    applyHeightGuard(data.model_height_mm);
    document.dispatchEvent(new CustomEvent('cf:cube:preview-ready', { detail: finished }));
    showOverlay(data, data.cached, data.elapsed_s);
  }
  /*
    `fatal` = the server gave a terminal answer for this design (error/not_found),
    so it can never finish and must leave the notifier registry or it would sit
    in "Your Designs" as a pending card forever. A local giving-up (inline poll
    timeout, network blip) is NOT fatal: the job is very likely still building,
    and the cross-page notifier keeps watching it to its own longer ceiling.
  */
  function onFailed(msg, runId, { designId = null, fatal = false } = {}) {
    if (runId !== previewRunId) return;
    stopPolling();
    setBtnLoading(false);
    if (fatal && designId) window.CF_NOTIFY?.clear(designId);
    /*
      The registry (and so the pending-card set) may have changed — the gallery
      lives in another IIFE and re-renders off this event.
    */
    document.dispatchEvent(new CustomEvent('cf:cube:preview-cancelled'));
    showError(msg || T.error_generic || 'Preview failed. Please try again.');
  }

  async function pollOnce(designId, deadline, runId) {
    if (!polling || runId !== previewRunId) return;
    if (Date.now() > deadline) {
      onFailed(T.error_timeout || 'Preview is taking longer than expected. Please try again.', runId);
      return;
    }
    try {
      const res = await fetch(`${API_URL}/preview/${encodeURIComponent(designId)}`);
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      const data = await res.json();
      if (data.status === 'ready')     { onReady(data, runId); return; }
      if (data.status === 'error')     { onFailed(data.detail, runId, { designId, fatal: true }); return; }
      if (data.status === 'not_found') { onFailed(T.error_generic, runId, { designId, fatal: true }); return; }
      /*
        Low-res model hero placeholder (Blender mode): show it blurred behind the
        "rendering…" UI as soon as it lands, ahead of the full hero.
      */
      if (data.placeholder_url) {
        /*
          Placeholder ready ⇒ generation done, hero rendering. Show it blurred AND
          snap the 6-step animation to the final "render" step so they agree
          (otherwise the synthetic timer can still be on an earlier step).
          The placeholder URL is presigned — its signature changes every poll, so
          compare on the stable object path (sans query) or we'd re-set the
          background-image each second and the browser re-decodes it → a flash.
        */
        const phKey = data.placeholder_url.split('?')[0];
        if (overlay && overlay.dataset.ph !== phKey) {
          overlay.style.setProperty('--cc-gen-ph', `url("${data.placeholder_url}")`);
          overlay.classList.add('has-ph');
          overlay.dataset.ph = phKey;
        }
      }
      applyStage(data);
      pollTimer = setTimeout(() => pollOnce(designId, deadline, runId), POLL_INTERVAL_MS);
    } catch (err) {
      pollTimer = setTimeout(() => pollOnce(designId, deadline, runId), POLL_INTERVAL_MS);
    }
  }
  /*
    "Already covered" gate: when the map sits on top of a hand-refined catalogue
    model, offer it before generating a custom one. Wired once here.
  */
  const nearbyModal = document.getElementById('cc-nearby-modal');
  function showNearbyGateModal(model) {
    if (!nearbyModal) { window.CF._skipNearbyGate = true; handleGetPreview(); return; }
    const name = (model.name || '').trim();
    const viewBtn = document.getElementById('cc-nearby-modal-view');
    if (viewBtn) {
      viewBtn.textContent = (viewBtn.dataset.tmpl || `View %name% ${PRODUCT}`).replace('%name%', name);
      viewBtn.href = model.url || '#';
    }
    const img = document.getElementById('cc-nearby-modal-img');
    if (img) {
      const src = model.img || model.imgSmall || '';
      img.hidden = !src;
      if (src) { img.src = src; img.alt = name; }
    }
    nearbyModal.show();
  }
  if (nearbyModal) {
    document.getElementById('cc-nearby-modal-proceed')?.addEventListener('click', () => {
      nearbyModal.hide();
      window.CF._skipNearbyGate = true;
      handleGetPreview();
    });
    /*  The cross, Escape or the backdrop = cancel (x-modal closes itself): stay on the map, nothing generated. */
  }

  async function handleGetPreview() {
    if (polling) return;
    if (window.CF.SESSION && typeof window.CF.SESSION.guardGenerate === 'function' && !window.CF.SESSION.guardGenerate()) {
      return;
    }
    if (!API_URL) {
      previewRunId += 1;
      setConfiguratorView('preview');
      setBtnLoading(false);
      showError(T.error_no_api || 'Preview service not configured.');
      return;
    }

    const mapState = window.CF_CUBE_CUSTOM_MAP?.getState?.();
    /*
      Deep-link/saved restore: generate from the EXACT saved coordinates (set by
      autoOrder), not the live map center that may have drifted after the flyTo —
      this reproduces the SAME design_id, so we continue the in-flight job instead
      of spawning a near-duplicate. One-shot. Override before the map-ready guard so
      a still-settling map can't block it.
    */
    const _rc = (window.CF && window.CF._restoreCoords) || null;
    window.CF._restoreCoords = null;
    if (_rc && mapState) {
      if (Number.isFinite(_rc.lat) && Number.isFinite(_rc.lon)) mapState.center = { lat: _rc.lat, lng: _rc.lon };
      if (Number.isFinite(_rc.scale))    mapState.scale = _rc.scale;
      if (Number.isFinite(_rc.rotation)) mapState.rotation = _rc.rotation;
    }
    if (!mapState?.center) {
      previewRunId += 1;
      setConfiguratorView('preview');
      setBtnLoading(false);
      showError(T.error_generic || 'Map not ready. Please wait.');
      return;
    }
    /*
      If a hand-refined catalogue model already covers ~this exact area, offer it
      first (no generation yet). The modal's "Proceed" re-runs with the gate
      skipped; saved-design restores set _skipNearbyGate before their auto-click.
    */
    if (!window.CF._skipNearbyGate) {
      const near = typeof window.CF?.nearestAlertModel === 'function'
        ? window.CF.nearestAlertModel(mapState.center.lat, mapState.center.lng) : null;
      if (near) { showNearbyGateModal(near); return; }
    }
    window.CF._skipNearbyGate = false;
    /*
      Saved-design restore (deep link) is covered by the full-screen splash until
      the existing design lands. It's a cache hit, so /preview returns "ready" in
      ~1s — but the deferred showGenerating() below fires at 250ms and the gen
      animation flashes for the rest of that gap (behind/through the fading
      splash). Suppress it for this one run; a genuinely-pending design still
      animates via the polling branch. One-shot — later generations animate.
    */
    const silentRestore = !!(window.CF && window.CF._silentRestore);
    window.CF._silentRestore = false;

    const { width_m, height_m } = frameDims(mapState.scale);

    clearError();
    hideOverlay();
    /*
      Bring the preview into view so the shopper actually sees the rendering
      animation — on mobile they may have scrolled well past it to the controls.
    */
    const stageEl = document.getElementById('cube-custom-preview-stage');
    if (stageEl && typeof stageEl.scrollIntoView === 'function') {
      stageEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    window.CF_CUBE_CUSTOM_PREVIEW = null;
    if (root) root.classList.remove('is-preview-ready');
    /*
      Clear the Trees/Streets selection from the PREVIOUS design so its buttons
      don't stay lit while the new design generates (they're re-derived from the
      new design's combo data once it lands via applyComboData).
    */
    treesOn = false; streetsOn = false;
    comboHasTrees = false; comboHasStreets = false;
    currentCombo = 'model';
    pendingRestore = null;
    syncComboButtons();
    const runId = ++previewRunId;
    setConfiguratorView('preview');
    setBtnLoading(true);
    /*
      `restore`: a saved design reopened (assets/cc-configurator-designs.js), not a new one — the
      tracking script (assets/cf-tracking.js) counts only new designs.
    */
    document.dispatchEvent(new CustomEvent('cf:cube:preview-start', { detail: {
      restore: silentRestore,
      lat: mapState.center.lat, lon: mapState.center.lng,
      scale: mapState.scale, rotation: mapState.rotation,
      place_name: (document.getElementById('cube-custom-location-place')?.textContent || '').trim(),
    }}));
    /*
      Remember this design's area so a faint marker frame shows where it was made
      when the shopper returns to the map for their next design.
    */
    window.CF_CUBE_CUSTOM_MAP?.setPreviousDesign?.({
      lat: mapState.center.lat, lon: mapState.center.lng,
      scale: mapState.scale, rotation: mapState.rotation,
    });

    if (genDeferTimer) clearTimeout(genDeferTimer);
    if (!silentRestore)
      genDeferTimer = setTimeout(() => { genDeferTimer = null; showGenerating(); }, GEN_OVERLAY_DELAY);

    try {
      const res = await fetch(`${API_URL}/preview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lat:      mapState.center.lat,
          lon:      mapState.center.lng,
          width_m,
          height_m,
          scale:    mapState.scale,
          /*
            Map bearing the shopper chose — the backend applies it as the model's
            Z rotation so the rendered preview matches the configured orientation.
            Without this the server falls back to 0° (every preview came out
            north-up regardless of the rotation control).
          */
          rotation: Number.isFinite(mapState.rotation) ? mapState.rotation : 0,
          store_country: (window.CF && window.CF.LOCALE && window.CF.LOCALE.countryCode) || null,
          staff: !!(window.CF && window.CF.IS_STAFF),
        }),
      });

      if (runId !== previewRunId) return;

      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        throw new Error(errBody.detail || `Server error ${res.status}`);
      }

      const data = await res.json();
      if (runId !== previewRunId) return;
      if (data.status === 'ready') { onReady(data, runId); return; }
      polling = true;
      lastRenderDesignId = data.design_id; /* track the in-flight render for supersede-cancel */
      /*
        Cross-page notifier: register this design so the shopper can browse away
        and still get a toast when it finishes (see snippets/cf-design-notify).
      */
      window.CF_NOTIFY?.register({
        id: data.design_id, product: KIND,
        title: (document.getElementById('cube-custom-location-place')?.textContent || '').trim(),
        lat: mapState.center.lat, lon: mapState.center.lng,
        scale: mapState.scale, rotation: mapState.rotation, path: location.pathname,
      });
      window.CF_NOTIFY?.setActive(data.design_id);
      if (genDeferTimer) { clearTimeout(genDeferTimer); genDeferTimer = null; }
      showGenerating();
      if (data.stage || data.buildings_count != null) applyStage(data);
      pollOnce(data.design_id, Date.now() + POLL_TIMEOUT_MS, runId);
    } catch (err) {
      onFailed(err.message, runId);
    }
  }

  function showDesign(entry) {
    if (!entry || !entry.design_id || !previewImg) return;
    /*
      Clear any stale height-guard from a previously shown design; the correct
      state is re-applied once this design's /preview data (with model_height_mm)
      lands via applyComboData → applyHeightGuard.
    */
    if (root) root.classList.remove('is-height-exceeded');
    /*
      Relabel the step-2/3 heading (and the map-step place label) to THIS design's
      place. showDesign previously never touched the title, so flipping between
      library designs left "Your <place> CUBE/FRAME" stuck on the last map selection.
    */
    const place = (entry.place_name || '').trim();
    const titleEl = document.getElementById('cf-v2-title');
    if (titleEl) {
      const tc = (window.CF && window.CF.T && window.CF.T.cube_custom) || {};
      titleEl.textContent = place
        ? (tc.title_place ? tc.title_place.replace('%place%', place) : `Your ${place} ${PRODUCT}`)
        : (tc.title_default || `Your Custom ${PRODUCT}`);
    }
    if (place) {
      const placeLabel = document.getElementById('cube-custom-location-place');
      if (placeLabel) placeLabel.textContent = place; /* keeps a re-save's buildEntry in sync */
    }
    window.CF_CUBE_CUSTOM_PREVIEW = {
      design_id: entry.design_id,
      preview_url: entry.preview_url,
      lat: entry.lat, lon: entry.lon, scale: entry.scale, rotation: entry.rotation,
      trees: !!entry.trees, streets: !!entry.streets,
      city: entry.city || '', area: entry.area || '', country: entry.country || '',
      place_name: entry.place_name || '',
    };
    window.CF.MARKER?.restore?.(entry.design_id, entry.marker); /* its location marker, before showOverlay shows it */
    /*
      Restore the saved configuration. Cover/plaque apply now (independent of the
      combo render); trees/streets are queued in pendingRestore and applied once
      real combo availability lands (applyComboData). Only when the entry actually
      carries config — otherwise fall back to the server's stored config.
    */
    if (('trees' in entry) || ('cover' in entry) || ('plaque' in entry)) {
      pendingRestore = {
        trees: !!entry.trees, streets: !!entry.streets,
        cover: entry.cover || 'none',
        plaque: entry.plaque || 'none',
        plaque_headline: entry.plaque_headline || '',
        plaque_subheadline: entry.plaque_subheadline || '',
      };
      cfApplyCoverPlaque(pendingRestore);
    } else {
      pendingRestore = null;
    }
    /*
      Remember this design's location so a faint marker frame shows where it was
      when the shopper returns to the map for their next design.
    */
    window.CF_CUBE_CUSTOM_MAP?.setPreviousDesign?.({
      lat: entry.lat, lon: entry.lon, scale: entry.scale, rotation: entry.rotation,
    });
    if (root) root.classList.add('is-preview-ready');
    revealPrice();
    setConfiguratorView('preview');
    showOverlay({ design_id: entry.design_id, preview_url: entry.preview_url }, true, 0);
  }
  function clearPreview() {
    stopPolling();
    setBtnLoading(false); /* reachable mid-generation now (removePending) — un-stick the button */
    hideOverlay();
    hidePrice();
    if (root) root.classList.remove('is-preview-ready');
    window.CF_CUBE_CUSTOM_PREVIEW = null;
    setConfiguratorView('location');
  }
  /*
    Attach the inline progress UI to a design that is ALREADY generating, without
    starting anything. This is what a pending gallery card and a ?design= deep
    link both go through — the old resume path re-POSTed /preview and relied on
    the server re-hashing identical coordinates back to the same design_id, which
    forked a second render on any drift.

    Deliberately does NOT set is-preview-ready: that class unlocks step
    navigation (setStepsClickable), reveals the price and enables Add to cart, and
    none of that may happen for a design whose geometry does not exist yet.
    onReady sets it when the design actually lands.
  */
  function watchPending(designId, opts = {}) {
    if (!designId || !API_URL) return false;
    if (polling && lastRenderDesignId === designId) return true;
    const runId = ++previewRunId; /* supersedes whatever the overlay was following */
    stopPolling(); /* stop watching the previous design — never cancel it */
    clearError();
    hideOverlay();
    hidePrice();
    if (root) root.classList.remove('is-preview-ready');
    window.CF_CUBE_CUSTOM_PREVIEW = null;
    pendingRestore = null;
    treesOn = false; streetsOn = false;
    comboHasTrees = false; comboHasStreets = false;
    currentCombo = 'model';
    syncComboButtons();
    const place = (opts.place_name || '').trim();
    if (place) {
      const titleEl = document.getElementById('cf-v2-title');
      const tc = (window.CF && window.CF.T && window.CF.T.cube_custom) || {};
      if (titleEl) titleEl.textContent = tc.title_place
        ? tc.title_place.replace('%place%', place) : `Your ${place} ${PRODUCT}`;
      const placeLabel = document.getElementById('cube-custom-location-place');
      if (placeLabel) placeLabel.textContent = place;
    }
    setConfiguratorView('preview');
    setBtnLoading(true);
    /*
      A deferred showGenerating() from a Generate click still in flight would fire
      with no args and quietly cancel the jump-ahead. Drop it first.
    */
    if (genDeferTimer) { clearTimeout(genDeferTimer); genDeferTimer = null; }
    showGenerating({ resuming: true }); /* jump the animation to the real progress */
    polling = true;
    lastRenderDesignId = designId;
    /*
      Make sure the cross-page notifier knows about this design. One opened from a
      SHARED link has no registry entry in THIS browser, so without this the
      shopper would get no toast on navigating away — the very feature the flow
      exists for. register() is idempotent, so the gallery-card path is a no-op.
      NOTE: title is only ever opts.place_name, never the DOM place label — that
      label still reads its hardcoded default until the reverse-geocode lands, and
      using it is what mislabelled phantom cards with the default city.
    */
    window.CF_NOTIFY?.register({
      id: designId, product: KIND, title: (opts.place_name || '').trim(),
      lat: opts.lat, lon: opts.lon, scale: opts.scale, rotation: opts.rotation,
      path: location.pathname,
    });
    window.CF_NOTIFY?.setActive(designId);
    pollOnce(designId, Date.now() + POLL_TIMEOUT_MS, runId);
    document.dispatchEvent(new CustomEvent('cf:cube:preview-cancelled')); /* re-render the gallery's active state */
    return true;
  }

  window.CF = window.CF || {};
  /*
    The location marker (assets/cc-location-marker.js) works through this: which design
    and combo are on screen, its own picture on the main slide and in step 3. It answers through window.CF.MARKER
    (onDesign, onCombo, addonFor, restore); without it nothing here does anything.
  */
  window.CF.MARKER_BRIDGE = {
    apiUrl: API_URL,
    design: () => currentDesignId,
    combo: () => comboKey(),
    comboHero: () => comboPreviews[comboKey()] || comboPreviews.model || null,
    setHero: (url) => setHeroImage(url, url),
    refreshAddon: () => {
      if (root && root.classList.contains('cc-custom-view-customize') && currentDesignId) {
        loadAddonBase(currentDesignId, addonComboFor(currentDesignId));
      }
    },
    /*
      The marker was set, moved, or turned on or off: extra views already asked for follow it, as on a combo switch
      (each keeps its picture until the new one is there).
    */
    refreshViews: () => {
      if (!viewsRequested || !currentDesignId) return;
      markExtraViewsReRendering();
      updateProcessingChip();
      triggerCarouselRender(currentDesignId, comboKey(), visibleExtraSlot());
      startViewsPolling(currentDesignId, comboKey());
    },
  };
  window.CF.CUBE_PREVIEW = {
    showDesign, clear: clearPreview, watchPending,
    /*
      Which still-generating design the inline overlay is following (or null) —
      lets the gallery mark that pending card active.
    */
    watchedPendingId: () => (polling ? lastRenderDesignId : null),
    generateAt: (coords) => {
      if (coords) window.CF._restoreCoords = coords;
      window.CF._skipNearbyGate = true;
      handleGetPreview();
    },
  };

  btn.addEventListener('click', handleGetPreview);
})();
